<template>
  <div class='plus-item'>
    <form-container :loading='loading' :hasData='!!model' @goBack='redirect'>
      <template #goback>
        Назад к списку промокодов
      </template>
      <template #heading>
        <h1 v-if='model.title'>{{ model.title }}</h1>
        <h1 v-else-if='$props.createMode'>Добавить промокоды</h1>
      </template>
      <template #content>
        <plus-form ref='form' :model='model'></plus-form>
      </template>
      <template #actions v-if='$props.createMode'>
        <div class='actions'>
          <button @click='onCreate'>Создать</button>
        </div>
      </template>
      <template #footer v-if='model.items.length'>
        <table-element v-bind='tableOpt'>
          <template #error="{ value }"><span v-bind:class="{ error: value, success: !value }">{{ value || 'Добавлен' }}</span></template>
        </table-element>
      </template>
    </form-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import TableElement from '@/components/common/TableElement';
import FormContainer from '@/components/common/FormContainer.vue';
import PlusForm from './PlusForm';
import PlusModel from '@/models/plus';

export default {
  name: 'plus-item',

  props: {
    createMode: Boolean,
  },

  components: {
    FormContainer,
    PlusForm,
    TableElement,
  },

  computed: {
    ...mapGetters({
      loading: 'plus/loading',
      currentItem: 'plus/currentItem',
    }),

    tableOpt() {
      return {
        list: this.model.items,

        columns: [
          { label: 'VIN', name: 'vin', width: '20%' },
          { label: 'Промокод', name: 'code', width: '20%' },
          { label: 'Статус', name: 'error', width: '20%' },
        ],

        order: {
          column: 'created_at',
          desc: true,
        },
      };
    },
  },

  watch: {
    currentItem(model) {
      this.model = new PlusModel(model);
    },
  },

  filters: {
    pretty: function(value) {
      return JSON.stringify(value, null, 2);
    },
  },

  methods: {
    ...mapActions({
      clearCurrentItem: 'plus/clearCurrentItem',
      create: 'plus/create',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    async validateForm() {
      return await this.$refs.form.validate();
    },

    async onCreate() {
      const validated = await this.validateForm();

      if (!validated) {
        return;
      }

      const err = await this.create(this.model);
      if (err) {
        this.toast(err, 'error');
        return;
      }

      this.toast('Запрос успешно обработан.', 'success');
    },

    redirect() {
      this.$router.push({ name: 'plus' });
    },

  },

  data() {
    return {
      model: null,
    };
  },

  beforeDestroy() {
    this.clearCurrentItem();
  },

  async beforeMount() {
    this.model = new PlusModel();
  },
};
</script>

<style lang='scss' scoped>
.plus-item {
  flex: 1;
}
</style>
